import { useMemo } from "react";
import React from "react-admin";
import BaseExportButton from "../../component/button/ExportButton";
import { get } from "lodash";

const ExportButton = ({ isAdmin, ...props }) => {
  const filterValues = { id: props?.record?.id };
  const visible = useMemo(() => {
    const currentState = get(props, "record.transaction.state", null);
    const isVisible =
      currentState !== "draft" && currentState !== null && isAdmin
        ? true
        : false;
    return isVisible;
  }, [props, isAdmin]);

  if (!visible) {
    return null;
  }

  return (
    <BaseExportButton
      {...props}
      currentSort={undefined}
      filterValues={filterValues}
    />
  );
};
export default ExportButton;
